<template>
    <LoadingVue v-if="isLoading" />
    <div class="loto" v-else>
        <TitleCommon title="lotto 5/90" :isShowButtonBack="true" />
        <GameLoto v-if="!isNodata" :dataSource="dataSource" />
        <div v-else class="loto__no-data">
            {{ getTranslatedText('no data') }}
        </div>
    </div>
</template>
<script>
import GameLoto from '@/components/loto/games/index.vue';
import LottoService from '@/services/loto/loto.service';
import languageMixins from '@/mixins/language-mixins';
import LoadingVue from '@/components/common/loading/loading.vue';
import TitleCommon from '@/components/common/title/index.vue';
import { isArrayEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { GameLoto, LoadingVue, TitleCommon },
    data() {
        return {
            dataSource: [],
            isLoading: true,
            isNodata: false,
        };
    },
    created() {
        this.$store.commit('SET_CART_GAME_EMPTY');
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const resp = await LottoService.getListGames();
                if (resp.code === 200 && !isArrayEmpty(resp.data)) {
                    const dataMultiloto = resp.data.reduce((acc, item) => {
                        const grouping = this.getTranslatedText(item.game.config.grouping.toLowerCase());
                        if (!acc[grouping]) {
                            acc[grouping] = [];
                        }
                        let itemGrouping = {
                            id: Math.random().toString(16).slice(2),
                            game_id: item.game.game_id,
                            name: item.game.name,
                            price: item.game.price,
                            minPick: item.game.config.picks[0],
                            maxPick: item.game.config.picks[0],
                            slug: item.game.slug,
                            type: 'okapi lottery',
                            balls: 90,
                            img: `${item.game.config.grouping}-${item.game.config.picks[0]}`,
                        };

                        if (
                            (item.game.slug.includes('5-90-lucky3') && this.$store.state.lotto.is_show_loto_lucky3) ||
                            (item.game.slug.includes('5-90-lucky4') && this.$store.state.lotto.is_show_loto_lucky4) ||
                            (item.game.slug.includes('5-90-lucky5') && this.$store.state.lotto.is_show_loto_lucky5)
                        ) {
                            acc[grouping].push(itemGrouping);
                            acc[grouping] = acc[grouping].sort((a, b) => a.minPick - b.minPick);
                        }
                        return acc;
                    }, {});
                    this.dataSource = dataMultiloto;
                    this.isLoading = false;
                } else {
                    this.isNodata = true;
                    this.isLoading = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/loto.scss';
</style>
